import React, { useState, Fragment } from "react";
import ViewCardBalance from "./ViewCardBalance";

// Registry of admin jobs. Adding a future job means adding one entry here plus its
// component - the container itself does not change.
const ADMIN_JOBS = [
  {
    key: "viewcardbalance",
    name: "View Card Balance",
    description:
      "Bulk read live card balances from the issuer for a list of cards.",
    component: ViewCardBalance,
  },
];

const AdminDashboard = () => {
  const [selectedJob, setSelectedJob] = useState(null);

  const renderJobList = () => {
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-12">
            <h3 className="mb-1">Admin Dashboard</h3>
            <p className="fs-12 clr-submarine mb-4">
              Administrative jobs and scheduled work.
            </p>
          </div>
        </div>
        <div className="row">
          {ADMIN_JOBS.map((job) => (
            <div className="col-md-6 mb-3" key={job.key}>
              <div
                className="bo-card-inner p-3"
                style={{ cursor: "pointer" }}
                onClick={() => setSelectedJob(job)}
              >
                <h5 className="mb-1">
                  <i className="icon-settings me-2"></i>
                  {job.name}
                </h5>
                <span className="fs-12 clr-submarine">{job.description}</span>
              </div>
            </div>
          ))}
        </div>
      </Fragment>
    );
  };

  const renderSelectedJob = () => {
    const JobComponent = selectedJob.component;
    return (
      <Fragment>
        <div className="row">
          <div className="col-md-12 mb-3">
            <a
              onClick={() => setSelectedJob(null)}
              style={{ cursor: "pointer", color: "blueviolet" }}
            >
              <b>&lsaquo; Back to Admin Dashboard</b>
            </a>
          </div>
        </div>
        <JobComponent />
      </Fragment>
    );
  };

  return (
    <div className="col-xl-9 col-lg-12 bo-main-content">
      {selectedJob === null ? renderJobList() : renderSelectedJob()}
    </div>
  );
};

export default AdminDashboard;
